import { useSelector } from 'react-redux';
import { FeatureFlags } from '../feature-flags';

export const useFeatureFlag = (featureFlag) => {
  const featureFlags = useSelector((state) => state.featureFlags);
  const featureFlagService = new FeatureFlags({ featureFlags });

  return featureFlagService.getFeatureFlag(featureFlag);
};
